export default "__VITE_ASSET__DYT4P4nj__"